export enum UserPermission {
  DealQuery = 'DealQuery',
  FixedIncomeDealMonitor = 'FixedIncomeDealMonitor',
  MunicipalStreetCalendar = 'MunicipalStreetCalendar',
  MunicipalDealMonitor = 'MunicipalDealMonitor',
  DealMonitorEnterprise = 'DealMonitorEnterprise',
  MunicipalMmdData = 'MunicipalMmdData',
  TrancheSizeLimitOrder = 'TrancheSizeLimitOrder',
  MunicipalGroupFollow = 'MunicipalGroupFollow',
  MunicipalCommenting = 'MunicipalCommenting',
  MuniAssignments = 'MuniAssignments',
  MuniPublicUser = 'MuniPublic',
  MuniPermissionedUser = 'MuniPermissioned',
  MunicipalInternalStatusInterested = 'MunicipalInternalStatusInterested',
  MunicipalInternalStatusNotApproved = 'MunicipalInternalStatusNotApproved',
  MunicipalInternalStatusInProgress = 'MunicipalInternalStatusInProgress',
  MunicipalInternalStatusApproved = 'MunicipalInternalStatusApproved',
  Designations = 'Designations'
}

export interface UserPermissions {
  permissions: UserPermission[];
  ipreoAccountUserId: string;
  buysideUserId: string;
}

export interface Permissions {
  mmd: boolean;
  competitiveBids: boolean;
  createBid: boolean;
  following: boolean;
  groupFollowing: boolean;
  assignments: boolean;
  commenting: boolean;
  ownership: boolean;
  marketDrawer: boolean;
  versionSelector: boolean;
  calendarPricing: boolean;
  internalTracking: boolean;
  internalStatusInterested: boolean;
  internalStatusNotApproved: boolean;
  internalStatusInProgress: boolean;
  internalStatusApproved: boolean;
  isMuniPublicUser: boolean;
  isMuniPermissionedUser: boolean;
  isDesignationsEnabled: boolean;
}
